<micro-select-combo #sel
              placeholder="Company"
              routerBase="companies"
              [mode]="mode"
              [(id)]="companyId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [jump]="jump"
              [blur]="onTouched"
>
</micro-select-combo>
